import SlideToggle from '~/components/common/SlideToggle.vue';
export default {
  name: 'PlanPicker',
  components: {
    SlideToggle
  },
  props: {
    plans: {
      type: Array,
      required: true
    },
    selectedPlan: {
      type: Number,
      default: -1
    },
    billingCycle: {
      type: Number,
      default: -1
    },
    showBillingCycleToggle: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    billingCycleBoolean: {
      get() {
        return Boolean(this.billingCycle);
      },
      set(val) {
        this.$emit('update:billingCycle', val ? 1 : 0);
      }
    },
    annualMaxDiscount() {
      return Math.max(...this.plans.map(plan => plan.price[0] * 12 - plan.price[1]));
    }
  }
};